import {
  IData,
  IProfile,
  IProfileData,
  IResponse,
} from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';

export default class ProfileService {
  public static fetchAndReturnProfile(): Promise<IResponse<IProfileData>> {
    return ApiService.getAndReturnData('profile/my');
  }

  public static saveAndReturnProfile(payload: IProfile): Promise<IResponse<IProfileData>> {
    return ApiService.postAndReturnData('profile/my/save', payload);
  }

  public static saveProfilePhoto(id: string): Promise<IResponse<IData<string>>> {
    return ApiService.postAndReturnData(`profile/my/photo/${id}`);
  }

  public static getProfileById(id: string): Promise<IResponse<IProfileData>> {
    return ApiService.getAndReturnData(`profile/foreign/${id}`);
  }

  public static resendConfirmationEmail(): Promise<IResponse<IProfileData>> {
    return ApiService.postAndReturnData('registration/resend/confirmation');
  }
}
